export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.8-1001.54",
  commitId: "ec9bd98b3b3fd5ccd678dcbf03e1489ed9a12399",
  commitTime: "2026-06-08T10:01:54.000Z",
});
